import { connect } from 'react-redux'
import MediaCarousel from './MediaCarousel'
import { MediaCarouselProps } from './types'
import { State } from '../../dataStore/reducers/reducerType'

const mapStateToProps = (state: State, props: Omit<MediaCarouselProps, 'isSidePanelOpen'>): MediaCarouselProps => ({
  ...props,
  isSidePanelOpen: state.ui.isSidePanelOpen
})

export default connect(mapStateToProps)(MediaCarousel)
